import { tryDoFetch } from "../../../lib/tryDoFetch";

export const doLogout = async () => {
  const json = await tryDoFetch("/research/japi/user/logout", null, "GET", onError);
  onSuccess(json);
};

const onSuccess = () => {
  window.location.assign("/research/m/public/login");
};

const onError = (err) => {
  console.error("Could not logout: ", err);
  window.location.assign("/research/m/public/login");
};
